import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('warning-fill-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.857 45c-11.598 0-21-9.402-21-21s9.402-21 21-21 21 9.402 21 21-9.402 21-21 21z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.96 13l.79 14.608h3.264L27.857 13H22.96zm2.308 17.806c.683 0 1.286.218 1.768.742.442.48.683 1.091.683 1.833 0 .786-.24 1.397-.683 1.877a2.452 2.452 0 0 1-1.768.742c-.683 0-1.246-.262-1.728-.742-.482-.524-.683-1.135-.683-1.877s.201-1.353.683-1.833c.482-.524 1.045-.742 1.728-.742z",
    fill: "#FFF"
  })));
});